const fulfillmentStatusMap = {
  FULFILLED: '発送済', // Fulfilled
  IN_PROGRESS: '処理中', // In progress
  ON_HOLD: '保留中', // On hold
  OPEN: '未発送', // Open (replaced by UNFULFILLED)
  PARTIALLY_FULFILLED: '一部発送済み', // Partially fulfilled
  PENDING_FULFILLMENT: '発送待ち', // Pending fulfillment
  RESTOCKED: '在庫に戻しました', // Restocked
  SCHEDULED: '発送予定', // Scheduled
  UNFULFILLED: '未発送', // Unfulfilled
};

function translateFulfillmentStatus(status) {
  return fulfillmentStatusMap[status] || status;
}

const financialStatusMap = {
  AUTHORIZED: '承認済み', // Authorized
  EXPIRED: '期限切れ', // Expired
  PAID: '支払い済み', // Paid
  PARTIALLY_PAID: '一部支払い済み', // Partially paid
  PARTIALLY_REFUNDED: '一部返金済', // Partially refunded
  PENDING: '保留', // Pending
  REFUNDED: '返金済み', // Refunded
  VOIDED: '無効', // Voided
};

function translateFinancialStatus(status) {
  return financialStatusMap[status] || status;
}
// convertToCurrency
function convertToCurrency(amount, currencyCode = 'JPY', showCurrencyCode = true) {
  const formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
  });
  
  const formattedAmount = formatter.format(amount);
  return showCurrencyCode ? `${formattedAmount} ${currencyCode}` : formattedAmount;
}

// convertToJapanDate
function convertToJapanDate(utcTime) {
  const date = new Date(utcTime);
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(date);

  const year = parts.find(p => p.type === 'year').value;
  const month = parts.find(p => p.type === 'month').value;
  const day = parts.find(p => p.type === 'day').value;

  return `${year}年${month}月${day}日`;
}

// convertToJapanDateTime
function convertToJapanDateTime(utcTime) {
  const date = new Date(utcTime);
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // 24h
  }).formatToParts(date);

  const year = parts.find(p => p.type === 'year').value;
  const month = parts.find(p => p.type === 'month').value;
  const day = parts.find(p => p.type === 'day').value;
  const hour = parts.find(p => p.type === 'hour').value;
  const minute = parts.find(p => p.type === 'minute').value;

  return `${year}年${month}月${day}日 ${hour}:${minute}`;
}

function safe(val, fallback = '') {
  return val === undefined || val === null ? fallback : val;
}

// checkLoginStatus
async function checkLoginStatus() {
  const loginSession = getEnvConfig().session_is_logged_in;
  const isLoggedIn = document.cookie.split('; ').find((row) => row.startsWith(loginSession + '='));
  if (!isLoggedIn || isLoggedIn.split('=')[1] !== 'true') {
    document.getElementById('login-notification').innerHTML =
      '<div style="color:#2da7e6; font-size:1.5em; text-align:center; padding:2em 0;">アイコンをクリックしてログインし、情報を表示してください。</div>';
    hideLoading('customer-loading');
    hideLoading('order-detail-loading');
    return false;
  }
  return true;
}

// Render pagination
function renderPagination(allApiData, apiDataPerPage, currentPage) {
  if (!allApiData) {
    console.error('customer have not data');
    return;
  }
  const totalPages = Math.ceil(allApiData.length / apiDataPerPage);
  const pagination = document.getElementById('pagination');
  pagination.innerHTML = '';

  const maxVisibleButtons = 4;
  const startPage = Math.max(1, currentPage - Math.floor(maxVisibleButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
  const firstPage = 1;
  const showPageWithDot = 2;
  if (startPage > firstPage) {
    pagination.innerHTML += `<span onclick="changePage(1)">1</span>`;
    if (startPage > showPageWithDot) {
      pagination.innerHTML += `<span>...</span>`;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    const isActive = i === currentPage ? 'aria-current="page"' : '';
    pagination.innerHTML += `<span ${isActive} onclick="changePage(${i})">${i}</span>`;
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pagination.innerHTML += `<span>...</span>`;
    }
    pagination.innerHTML += `<span onclick="changePage(${totalPages})">${totalPages}</span>`;
  }
}